import React, { Component } from 'react';
import classNames from 'classnames';
import { Success, Error } from '../../../common/icons';
import styles from './style.scss';

export default class ActionResult extends Component {

    render() {

        return(               
            <span className={classNames(styles.actionResultWrapper)}>
                {
                    this.props.error ? <Error /> : <Success />
                }
                <span className={classNames(
                                    styles.actionText,
                                    this.props.error && styles.actionFailedText
                                )
                            }
                >
                    {this.props.text}
                </span>
            </span> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapTestConnectionButtonContainer/actionResult/index.jsx